import styled from "styled-components";

export const TableContainer = styled.div<{ $noData?: boolean }>`
    .ant-table {
        margin-bottom: ${props => props.$noData ? "12px" : "0"};
        border-top: 1px solid ${props => props.theme.components.table.tableBorderColor};
        border-bottom: 1px solid ${props => props.theme.components.table.tableBorderColor};
        border-radius: 0;
    }

    .ant-table-cell {
        background: ${props => props.theme.components.table.actionCellBgColor} !important;
        border-bottom-color: ${props => props.theme.components.table.cellBorderColor} !important;
        transition: none !important;
        
        svg {
            stroke-width: 1.75px;
        }
    }

    .ant-table-pagination-right {
        align-items: center;
    }

    .ant-table-selection-column {
        padding-inline-start: 20px !important;
    }

    .ant-pagination {
        margin: 16px !important;
    }

    .ant-table-body {
        scrollbar-color: auto;
        scrollbar-width: auto;
    }
`;
